import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { down } from 'styled-breakpoints';

import { buildHandleEnterKeyPress } from '../utils/accessibility';

import closeImg from './close-x.png';

const Tooltip = ({
  active,
  arrowAlign,
  children,
  onClose,
  parentId,
  position = {},
}) => {
  return (
    <Container arrowAlign={arrowAlign} isActive={active} style={{ position }}>
      {children}

      {onClose && (
        <div
          className="close-container"
          onClick={onClose}
          onKeyPress={buildHandleEnterKeyPress(onClose)}
          tabIndex={0}
        >
          <img alt="Close" className="close" src={closeImg} />
        </div>
      )}
    </Container>
  );
};

Tooltip.propTypes = {
  active: PropTypes.bool,
  arrowAlign: PropTypes.oneOf(['left', 'right']),
  onClose: PropTypes.func,
};

Tooltip.defaultProps = {
  active: false,
  arrowAlign: 'right',
};

const Container = styled.div`
  display: ${props => (props.isActive ? 'flex' : 'none')};
  justify-content: space-between;
  bottom: calc(100% + 12px);
  right: ${props => (props.arrowAlign === 'right' ? -5 : -115)}px;
  background-color: ${props => props.theme.background};
  border: ${props => `1px solid ${props.theme.border}`};
  border-radius: 3px;
  box-shadow: ${props => `0 1px 10px -1px ${props.theme.darkGray}`};
  padding: 1em;
  position: absolute;
  z-index: 2;

  ${down('sm')} {
    padding: 0.15em;
  }

  &:before {
    border: 1px solid transparent;
    border-top-color: ${props => props.theme.border};
    border-width: 11px;
    content: '';
    height: 0;
    width: 0;
    pointer-events: none;
    position: absolute;
    top: 100%;
    right: ${props =>
      props.arrowAlign === 'right' ? '19px' : 'calc(50% - 11px)'};
  }
  &:after {
    border: solid transparent;
    border-top-color: ${props => props.theme.background};
    border-width: 10px;
    content: '';
    height: 0;
    width: 0;
    pointer-events: none;
    position: absolute;
    top: 100%;
    right: ${props =>
      props.arrowAlign === 'right' ? '20px' : 'calc(50% - 10px)'};
  }

  .close-container {
    cursor: pointer;
    display: inline-block;
    height: 15px;
    margin: auto 5px;
    padding: 5px;
    ${down('sm')} {
      margin: auto 3px;
    }

    .close {
      height: 15px;
      width: 15px;
      right: 0;
    }
  }
`;

export default Tooltip;
